import { dashboardTypes } from "./dashboardTypes";

const INITIAL_STATE = {
  errorMessage: "",
  isOutlookLogin: false,
};

export default (state, action) => {
  if (!state) state = INITIAL_STATE;
  switch (action.type) {
    case dashboardTypes.DASHBOARD_ONCHANGE:
      return {
        ...state,
        errorMessage: "",
        [action.payload.prop]: action.payload.value,
      };
    default:
      return state;
  }
};
